export function requestRetry(
  url,
  options,
  maxAttempts = 3,
  currentAttempt = 1,
) {
  let delay = 500 * currentAttempt;
  return fetch(url, options)
    .then(async (response) => {
      if (!response.ok) {
        // 4xx = client error — retrying won't help
        if (response.status >= 400 && response.status < 500) {
          const errorData = await response.json().catch(() => ({}));
          const err = new Error(`Client error ${response.status}`);
          err.status = response.status;
          err.data = errorData;
          throw err;
        }
        throw new Error("Request failed");
      }
      return response.json();
    })
    .catch((error) => {
      // Never retry client errors
      if (error.status >= 400 && error.status < 500) {
        throw error;
      }
      if (currentAttempt < maxAttempts) {
        console.log(`Attempt ${currentAttempt} failed, retrying again...`);
        const nextAttempt = currentAttempt + 1;
        // Wait for delay before retrying
        return new Promise((resolve) => setTimeout(resolve, delay)).then(() =>
          requestRetry(url, options, maxAttempts, nextAttempt),
        );
      } else {
        throw error;
      }
    });
}
